package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

import androidx.compose.runtime.Immutable
import dev.icerock.moko.resources.desc.StringDesc

@Immutable
sealed interface OverflowPresentation {

    /**
     * Show the same icon that is used on the toolbar (if any) inside the overflow row.
     */
    data object IconAndText : OverflowPresentation

    /**
     * Show text only (no icon) inside overflow.
     * This matches your requirement: "If item is InOverflow, allow the icon to be not shown".
     */
    data object TextOnly : OverflowPresentation

    /**
     * Optional: allow overriding the overflow icon (rarely needed).
     */
    data class Custom(
        val icon: ToolbarIcon? = null,
        val text: StringDesc? = null,
        val forceTextOnly: Boolean = false,
    ) : OverflowPresentation
}
